// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeSearchBar_wrap__WsNzh","icon":"MicrositeSearchBar_icon__n+ctq","input":"MicrositeSearchBar_input__zWOvY","clearBtn":"MicrositeSearchBar_clearBtn__sPWhw"};